import {
    IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST,
    IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_RESULT,
    IMPORT_ACCOUNT_NEW_MIGRATION_OPEN_MODAL,
    IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST,
    IMPORT_ACCOUNT_SEARCH_ACCOUNTS_RESULT,
    IMPORT_ACCOUNT_GET_ACCOUNT_REQUEST,
    IMPORT_ACCOUNT_GET_ACCOUNT_RESULT,
    IMPORT_ACCOUNT_GET_STATUS_REQUEST,
    IMPORT_ACCOUNT_GET_STATUS_RESULT,
    IMPORT_ACCOUNT_IMPORT_REQUEST,
    IMPORT_ACCOUNT_IMPORT_RESULT,
    IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST,
    IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_RESULT,
    IMPORT_ACCOUNT_UPDATE_MIGRATION_LOG_REQUEST,
    IMPORT_ACCOUNT_UPDATE_MIGRATION_LOG_RESULT,
} from 'Redux/actionTypes';

export const importAccountOpenModal = (open) => ({
    type: IMPORT_ACCOUNT_NEW_MIGRATION_OPEN_MODAL,
    payload: open
})

export const importAccountSearchRequest = (data) => ({
    type: IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST,
    payload: data
})

export const accountsImportSearchAccountResult = (result) => ({
    type: IMPORT_ACCOUNT_SEARCH_ACCOUNTS_RESULT,
    payload: result
})

export const importAccountGetRequest = (data) => ({
    type: IMPORT_ACCOUNT_GET_ACCOUNT_REQUEST,
    payload: data
})

export const importAccountGetResult = (result) => ({
    type: IMPORT_ACCOUNT_GET_ACCOUNT_RESULT,
    payload: result
})

export const importAccountRequest = (data) => ({
    type: IMPORT_ACCOUNT_IMPORT_REQUEST,
    payload: data
})

export const importAccountResult = (result) => ({
    type: IMPORT_ACCOUNT_IMPORT_RESULT,
    payload: result
})

export const importAccountGetStatusRequest = (data) => ({
    type: IMPORT_ACCOUNT_GET_STATUS_REQUEST,
    payload: data
})

export const importAccountGetStatusResult = (result) => ({
    type: IMPORT_ACCOUNT_GET_STATUS_RESULT,
    payload: result
})

export const accountsGetImportByPxRequest = (data) => ({
    type: IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST,
    payload: data
})

export const importAccountGetAccountByPxResult = (data) => ({
    type: IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_RESULT,
    payload: data
})

export const importAccountGetMigrationAccountRequest = (data) => ({
    type: IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST,
    payload: data
})

export const importAccountGetMigrationAccountResult = (data) => ({
    type: IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_RESULT,
    payload: data
})

export const importAccountUpdateMigrationLogRequest = (data) => ({
    type: IMPORT_ACCOUNT_UPDATE_MIGRATION_LOG_REQUEST,
    payload: data
})

export const importAccountUpdateMigrationLogResult = (data) => ({
    type: IMPORT_ACCOUNT_UPDATE_MIGRATION_LOG_RESULT,
    payload: data
})